import Vue from 'vue';
import Component from 'vue-class-component';
import { Async } from '@/utils/AsyncDecorators';
import { store } from '@/store';
import { areaBoscoDaSemeStore } from '../../store/areaBoscoDaSeme.store';

@Component({})
export default class DashboardItem extends Vue{
    
    @Async({ async get() { return await areaBoscoDaSemeStore.getters.getAll() }, default: [], lazy: true })
    areeBoscoDaSeme: server.areaSaggio[];

    get numeroTotale(){
        return this.areeBoscoDaSeme.length;
    }

    get areaTotale(){
        var tot=0;
        for (var area of this.areeBoscoDaSeme) {
            tot = tot + area.area;
        }
        return tot;
    }

    goTo(routeName) {
        store.actions.ui.toggleDrawerMenu(false);
        store.actions.ui.toggleUserMenu(false);
        this.$router.push({ name: routeName })
    }

}